export default "__VITE_ASSET__D85AvWgF__"